import type {TemplateSummaryType} from 'src/components/workflow/templates/types';
import type {PlaybookAction} from 'src/action-creators/playbooks';

import {RECEIVE, RECEIVE_ALL} from 'src/action-creators/playbooks';


type PlaybookState = {
  playbooks: Array<TemplateSummaryType>;
  playbookDetails: TemplateSummaryType;
};

const initialState = {
  playbooks: [],
  playbookDetails: {},
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly playbooks: readonly []; readonly playbookDetails: {}; }' is not assignable to type 'PlaybookState'.
  state: PlaybookState | null | undefined = initialState,
  action: PlaybookAction,
): PlaybookState => {
  switch (action.type) {
    case RECEIVE_ALL:
      // @ts-expect-error - TS2322 - Type '{ playbooks: TemplateSummaryType[]; playbookDetails?: TemplateSummaryType | undefined; }' is not assignable to type 'PlaybookState'.
      return {
        ...state,
        playbooks: action.payload,
      };

    case RECEIVE:
      const playbook = action.payload;
      // @ts-expect-error - TS2322 - Type '{ playbookDetails: { id: string; name: string; business_goal: string; target: string; life_cycle_goal: string; recommendedUseCase: string; description: string; }; playbooks?: TemplateSummaryType[] | undefined; }' is not assignable to type 'PlaybookState'.
      return {
        ...state,
        playbookDetails: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.playbookDetails,
          [playbook.id]: playbook,
        },
      };
  }

  // @ts-expect-error - TS2322 - Type 'PlaybookState | null' is not assignable to type 'PlaybookState'.
  return state;
};
